const SITE_URL = 'https://itaobuyspread.lat';
const SITE_NAME = 'Itaobuy Spreadsheet Italia';
const SITE_DESC = "Itaobuy Spreadsheet Italia: la guida italiana più completa e aggiornata. Scopri come utilizzare Itaobuy Spreadsheet, le categorie prodotti, la sicurezza e i consigli per risparmiare tempo.";
const LOGO_URL = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg';

export const siteJsonLd = {
  '@type': 'WebSite',
  name: SITE_NAME,
  url: SITE_URL,
  description: SITE_DESC,
  inLanguage: 'it',
  publisher: {
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
    logo: {
      '@type': 'ImageObject',
      url: LOGO_URL,
      width: 512,
      height: 512,
    },
  },
};

export interface ArticleSeoData {
  title: string;
  description: string;
  slug: string;
  datePublished: string;
  dateModified: string;
  authorName: string;
  heroImage: string;
  breadcrumbItems: { name: string; item: string }[];
  faqs: { question: string; answer: string }[];
}

export function buildArticleJsonLd(seo: ArticleSeoData): Record<string, unknown>[] {
  const articleUrl = `${SITE_URL}${seo.slug}`;

  const article = {
    '@type': 'Article',
    headline: seo.title,
    description: seo.description,
    url: articleUrl,
    datePublished: seo.datePublished,
    dateModified: seo.dateModified,
    author: {
      '@type': 'Person',
      name: seo.authorName,
    },
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      url: SITE_URL,
      logo: {
        '@type': 'ImageObject',
        url: LOGO_URL,
      },
    },
    image: seo.heroImage,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': articleUrl,
    },
    inLanguage: 'it',
  };

  const breadcrumb = {
    '@type': 'BreadcrumbList',
    itemListElement: seo.breadcrumbItems.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.item,
    })),
  };

  const faq = {
    '@type': 'FAQPage',
    mainEntity: seo.faqs.map((f) => ({
      '@type': 'Question',
      name: f.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: f.answer,
      },
    })),
  };

  return [article, breadcrumb, faq];
}